import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { ICON_TYPE, IconModule, SiteContextComponentService, SiteContextType } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';

@Component({
  selector: 'select-context',
  standalone: true,
  imports: [CommonModule, IconModule, I18nModule],
  templateUrl: './select-context.component.html',
  styleUrl: './select-context.component.scss',
})
export class SelectContextComponent implements OnInit, OnDestroy {
  @Input() context!: SiteContextType;
  @Output() qtyItens = new BehaviorSubject(false);

  iconTypes = ICON_TYPE;
  subscription = new Subscription();

  constructor(
    private componentService: SiteContextComponentService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.items$.subscribe(items => {
        this.qtyItens.next(items.length);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get items$(): Observable<any> {
    return this.componentService.getItems(this.context);
  }

  get activeItem$(): Observable<string> {
    return this.componentService.getActiveItem(this.context);
  }

  set active(value: string) {
    this.componentService.setActive(value, this.context);
  }

  get label$(): Observable<any> {
    return this.componentService.getLabel(this.context);
  }

  closeModal() {
    this.modalService.close();
  }
}
